/**
 * The workbench tabs, in order. `key` is the message key under
 * `workbench.page.tabs`; `aiLabel` is the English name the AI chat endpoint
 * receives as `context.tab` (data sent to the backend, never translated).
 */
export const WORKBENCH_TABS = [
  { key: 'review', aiLabel: 'Review & Resolve' },
  { key: 'visualizer', aiLabel: 'Match Visualizer' },
  { key: 'workflow', aiLabel: 'Workflow & Audit' },
] as const

export type WorkbenchTabKey = (typeof WORKBENCH_TABS)[number]['key']
